// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { ListOperationsData, ListOperationsResponses, RunOperationData, RunOperationErrors, RunOperationResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class DataAdminService {
    /**
     * List Available Operations
     */
    public static listOperations<ThrowOnError extends boolean = true>(options?: Options<ListOperationsData, ThrowOnError>): RequestResult<ListOperationsResponses, unknown, ThrowOnError, 'data'> {
        return (options?.client ?? client).get<ListOperationsResponses, unknown, ThrowOnError, 'data'>({
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/operations',
            ...options
        });
    }
    
    /**
     * Run Operation
     */
    public static runOperation<ThrowOnError extends boolean = true>(options: Options<RunOperationData, ThrowOnError>): RequestResult<RunOperationResponses, RunOperationErrors, ThrowOnError, 'data'> {
        return (options.client ?? client).post<RunOperationResponses, RunOperationErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            responseStyle: 'data',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/operations/{name}',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}
